<template>
  <el-dialog :title="$t('searchMeterArchive.title')" :visible.sync="visible" width="90%">

    <el-row :gutter="20">
      <el-col :span="6">
        <el-input v-model="searchMeterInfo.meterAddr" :placeholder="$t('searchMeterArchive.meterAddrPlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchMeterInfo.userName" :placeholder="$t('searchMeterArchive.userNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchMeterInfo.roomName" :placeholder="$t('searchMeterArchive.roomPlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-select v-model="searchMeterInfo.funType" :placeholder="$t('searchMeterArchive.meterTypePlaceholder')" clearable>
          <el-option :label="$t('searchMeterArchive.waterMeter')" value="1"></el-option>
          <el-option :label="$t('searchMeterArchive.electricMeter')" value="2"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 15px;">
      <el-col :span="24" style="text-align: right;">
        <el-button type="primary" @click="searchMeterArchives">
          <i class="el-icon-search"></i>{{ $t('common.search') }}
        </el-button>
        <el-button type="primary" @click="resetMeterArchives">
          {{ $t('common.reset') }}
        </el-button>
      </el-col>
    </el-row>

    <div class="table-responsive" style="margin-top:15px">
      <el-table :data="searchMeterInfo.meterArchives" border>
        <el-table-column prop="meterAddr" :label="$t('searchMeterArchive.meterAddr')" align="center"></el-table-column>
        <el-table-column prop="userName" :label="$t('searchMeterArchive.userName')" align="center"></el-table-column>
        <el-table-column prop="userCode" :label="$t('searchMeterArchive.userCode')" align="center"></el-table-column>
        <el-table-column prop="roomName" :label="$t('searchMeterArchive.roomName')" align="center"></el-table-column>
        <el-table-column prop="meterType" :label="$t('searchMeterArchive.meterType')" align="center">
          <template slot-scope="scope">
            {{ getMeterTypeName(scope.row.funType) }}
          </template>
        </el-table-column>
        <el-table-column prop="balance" :label="$t('searchMeterArchive.balance')" align="center">
          <template slot-scope="scope">
            {{ scope.row.balance || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="onlineState" :label="$t('searchMeterArchive.onlineState')" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.onlineState === 1 ? 'success' : 'danger'">
              {{ scope.row.onlineState === 1 ? $t('searchMeterArchive.online') : $t('searchMeterArchive.offline') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="valveState" :label="$t('searchMeterArchive.valveState')" align="center">
          <template slot-scope="scope">
            <el-tag :type="getValveStateType(scope.row.valveState)">
              {{ getValveStateName(scope.row.valveState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="lastConTime" :label="$t('searchMeterArchive.lastConTime')" align="center" width="140"></el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="chooseMeterArchive(scope.row)">
              {{ $t('common.select') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.current"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="page.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      style="margin-top: 20px;">
    </el-pagination>

  </el-dialog>
</template>

<script>
import { queryMeterUserArchives } from '@/api/room/meterArchiveApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'searchMeterArchive',
  data() {
    return {
      visible: false,
      searchMeterInfo: {
        meterArchives: [],
        meterAddr: '',
        userName: '',
        roomName: '',
        funType: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  methods: {
    open() {
      this.visible = true
      this._refreshSearchMeterData()
      this._loadAllMeterArchiveInfo(1, 10)
    },
    async _loadAllMeterArchiveInfo(page, size) {
      try {
        const params = {
          page: page,
          row: size,
          communityId: getCommunityId(),
          meterAddr: this.searchMeterInfo.meterAddr.trim(),
          userName: this.searchMeterInfo.userName.trim(),
          roomName: this.searchMeterInfo.roomName.trim(),
          funType: this.searchMeterInfo.funType
        }

        const res = await queryMeterUserArchives(params)
        this.searchMeterInfo.meterArchives = res.data || []
        this.page.total = res.total || 0
        this.page.current = page
        this.page.size = size
      } catch (error) {
        console.error('获取表档案信息失败:', error)
        this.searchMeterInfo.meterArchives = []
        this.page.total = 0
      }
    },
    chooseMeterArchive(meterArchive) {
      this.$emit('chooseMeterArchive', meterArchive)
      this.visible = false
    },
    searchMeterArchives() {
      this._loadAllMeterArchiveInfo(1, this.page.size)
    },
    resetMeterArchives() {
      this.searchMeterInfo.meterAddr = ""
      this.searchMeterInfo.userName = ""
      this.searchMeterInfo.roomName = ""
      this.searchMeterInfo.funType = ""
      this._loadAllMeterArchiveInfo(1, this.page.size)
    },
    handleSizeChange(val) {
      this.page.size = val
      this._loadAllMeterArchiveInfo(1, val)
    },
    handleCurrentChange(val) {
      this._loadAllMeterArchiveInfo(val, this.page.size)
    },
    _refreshSearchMeterData() {
      this.searchMeterInfo = {
        meterArchives: [],
        meterAddr: '',
        userName: '',
        roomName: '',
        funType: ''
      }
      this.page = {
        current: 1,
        size: 10,
        total: 0
      }
    },
    getMeterTypeName(funType) {
      const types = {
        '1': this.$t('searchMeterArchive.waterMeter'),
        '2': this.$t('searchMeterArchive.electricMeter')
      }
      return types[funType] || this.$t('searchMeterArchive.unknownType')
    },
    getValveStateType(valveState) {
      const types = {
        '1': 'success', // 开
        '2': 'info',    // 关
        '3': 'danger'   // 异常
      }
      return types[valveState] || 'info'
    },
    getValveStateName(valveState) {
      const states = {
        '1': this.$t('searchMeterArchive.valveOpen'),
        '2': this.$t('searchMeterArchive.valveClose'),
        '3': this.$t('searchMeterArchive.valveException')
      }
      return states[valveState] || this.$t('searchMeterArchive.valveClose')
    }
  }
}
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
</style>